<lib-dynamic-listing
  [module]="'asset_write_off'"
  [filters]="filterConfigs"
  [columns]="columnConfigs"
  [data]="tableData"
  [actions]="actionConfigs"
  [isLoading]="isLoading"
  [pageIndex]="pageIndex"
  [rowsPerPage]="rowsPerPage"
  [totalCount]="totalCount"
  [totalPages]="totalPages"
  [columnPreferenceId]="columnPreferenceId"
  [exportFilename]="exportFilename"
  (filterEvent)="onFilterEvent($event)"
  (actionClicked)="onActionClicked($event)"
  (pageChanged)="onPageChanged($event)"
  (columnPreferenceSaved)="onColumnPreferenceSaved($event)"
  (exportCsv)="exportCsv()"
  (exportXlsx)="exportXlsx()"
  (columnsSelected)="onColumnsSelected($event)">
</lib-dynamic-listing>
